import ToolkitListItem from "./ToolkitListItem";
import {
  READ_ALONGS,
  BEDTIME_STORIES,
  TABLE_TOPICS,
  MUSIC,
  MINDFULNESS,
  BRUSH_TEETH,
  SHAKE_SILLIES,
  WHOSE_TURN,
} from "utils/beyondToolkitTools";
import styles from "./BedtimeList.module.css";

type BedtimeListProps = {
  isPremiumUnlocked: boolean;
  lockedUrl: string;
};

function BedtimeList(props: React.PropsWithChildren<BedtimeListProps>) {
  const bedtimeToolsList = [
    READ_ALONGS(),
    BRUSH_TEETH(),
    SHAKE_SILLIES(),
    WHOSE_TURN(),
    BEDTIME_STORIES(),
    TABLE_TOPICS(),
    MUSIC(),
    MINDFULNESS(),
  ];

  return (
    <div className={styles.list}>
      {bedtimeToolsList.map((tool) => {
        return (
          <ToolkitListItem
            key={tool.title}
            size="large"
            {...tool}
            isLocked={!tool.unlocked && !props.isPremiumUnlocked}
            lockedUrl={props.lockedUrl}
          />
        );
      })}
    </div>
  );
}

export default BedtimeList;
